<div class="d-flex flex-column justify-content-center align-items-center image-wrapper"
    [ngClass]="{'loader-border': loadingImage}">
    <ng-container [ngSwitch]="loaderType" *ngIf="loadingImage">
        <div class="shimmer-loader" *ngSwitchCase="LOADER_TYPES.SHIMMER"></div>
        <ng-container *ngSwitchCase="LOADER_TYPES.SPINNER">
            <div class="spinner-overlay">
                <div class="spinner"></div>
            </div>
        </ng-container>
        <div *ngSwitchDefault>
            <img src="assets/images/image-loader.gif" class="image-loader" alt="fetching-image" srcset="">
        </div>
    </ng-container>
    <img [src]="src" [alt]="alt" [ngClass]="{'d-none':loadingImage}" (load)="onImageLoad()" class="main-img" />
</div>